import { render } from "./EditTariffZonePage.vue?vue&type=template&id=70e27758&ts=true"
import script from "./EditTariffZonePage.vue?vue&type=script&lang=ts"
export * from "./EditTariffZonePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__